import { Fragment } from "react";

export const Marquee = ({ items = [], dark = false, testId = "marquee" }) => {
  const row = [...items, ...items];
  return (
    <div data-testid={testId} className={`relative overflow-hidden border-y py-7 md:py-10 ${dark ? "border-[#e6ca7a]/15 bg-[#0e0c0a]" : "border-[#b8893b]/20 bg-[#f3eadb]"}`}>
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center" aria-hidden={k === 1}>
            {row.map((it, i) => (
              <Fragment key={`${k}-${i}`}>
                <span className={`font-display px-6 text-4xl italic md:px-10 md:text-7xl ${i % 2 ? "text-outline-gold" : dark ? "text-[#f3e6c8]" : "text-[#3d2a14]"}`}>{it}</span>
                <span className="text-xl text-[#b8893b] md:text-3xl">✦</span>
              </Fragment>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
